import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';

export async function fetchReportingHierarchy(userId) {
  const params = new URLSearchParams();
  if (userId) {
    params.set('user_id', String(userId));
  }
  const query = params.toString();
  const url = query
    ? `${Config.user.reportingHierarchy}?${query}`
    : Config.user.reportingHierarchy;

  const res = await callWebService(callTypes.get, '', url);

  if (res?.data?.status === 0) {
    return res.data.data;
  }

  const message = res?.data?.message || 'Failed to load reporting hierarchy';
  throw new Error(message);
}
